<template>
    <div ref="container">
        <a-modal :title="title" :width="1600" :visible="visible" :confirmLoading="confirmLoading" :getContainer="() => $refs.container" :maskStyle="{'top':'93px','left':'200px'}" :wrapClassName="wrapClassNameInfo()" :mask="isDesktop()" :maskClosable="false" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="height: 80%;">
            <template slot="footer">
            <a-button key="back" @click="handleCancel">
                关闭
            </a-button>
            <a-button type="primary" @click="handleOk">
                确认
            </a-button>
            </template>
            <a-spin :spinning="confirmLoading">
<!--                <a-button type="primary" v-if="!port" style="margin-bottom: 10px" @click="chooseSerial">扫码获取</a-button>-->
                <div class="productInfo">
                  <a-form-model ref="form" :model="form" :rules="rules">
                    <span class="title">商品基本信息</span>
                      <a-row class="form-row">
                        <a-col :span="12/1">
                            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="编码" prop="code">
                                <a-input placeholder="请输入编码" v-model="form.code" />
                                <a-button type="primary" class="searchCode" @click="getProductInfo">查询</a-button>
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="12/1">
                          <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="品类码" prop="categoryCode">
                            <a-input placeholder="请输入品类码" v-model="form.categoryCode" />
                          </a-form-model-item>
                        </a-col>
                        <a-col :span="12/1" v-show="false">
                          <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="标识编码" prop="identificationCode">
                            <a-input placeholder="请输入标识编码" v-model="form.identificationCode" />
                          </a-form-model-item>
                        </a-col>
                        <a-col :span="12/1">
                          <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品名称" prop="productName">
                            <a-input placeholder="请输入产品名称" v-model="form.productName" />
                          </a-form-model-item>
                        </a-col>
                        <a-col :span="12/1">
                          <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="生产批号" prop="batchNumber">
                            <a-input placeholder="请输入生产批号" v-model="form.batchNumber" />
                          </a-form-model-item>
                        </a-col>
                        <a-col :span="12/1">
                          <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="规格/型号" prop="specificationModel">
                           <a-input placeholder="请输入规格/型号" v-model="form.specificationModel" />
                          </a-form-model-item>
                        </a-col>
                        <a-col :span="12/1">
                          <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品类别" prop="productCategory">
                            <a-input placeholder="请输入产品类别" v-model="form.productCategory" />
                          </a-form-model-item>
                        </a-col>
                        <a-col :span="12/1">
                          <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="器械类别" prop="instrumentCategory">
                            <a-input placeholder="请输入器械类别" v-model="form.instrumentCategory" />
                          </a-form-model-item>
                        </a-col>
                        <a-col :span="12/1">
                          <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品描述" prop="productDescription">
                            <a-input placeholder="请输入产品描述" v-model="form.productDescription" />
                          </a-form-model-item>
                        </a-col>
                        <a-col :span="12/1">
                          <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="储运条件" prop="storageTransportConditions">
                            <a-input placeholder="请输入储运条件" v-model="form.storageTransportConditions" />
                          </a-form-model-item>
                        </a-col>
                        <a-col :span="12/1">
                          <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="注册/备案证号" prop="registrationFilingNo">
                            <a-input placeholder="请输入注册/备案证号" v-model="form.registrationFilingNo" />
                          </a-form-model-item>
                        </a-col>
                        <a-col :span="12/1">
                          <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="医疗器械管理类别" prop="medicalDeviceManagementCategory">
                            <a-input placeholder="请输入医疗器械管理类别" v-model="form.medicalDeviceManagementCategory" />
                          </a-form-model-item>
                        </a-col>

                        <span class="enterpriseTitle">企业基本信息</span>
                        <a-col :span="12/1">
                          <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="生产企业" prop="manufacturer">
                            <a-input placeholder="请输入生产企业" v-model="scannerCodeSupplierVO.manufacturer" />
                          </a-form-model-item>
                        </a-col>
                        <a-col :span="12/1">
                          <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="营业执照号" prop="businessLicenceNumber">
                            <a-input placeholder="请输入营业执照号" v-model="scannerCodeSupplierVO.businessLicenceNumber" />
                          </a-form-model-item>
                        </a-col>
                        <a-col :span="12/1">
                          <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="附件">
                            <j-image-upload v-model="scannerCodeSupplierVO.attachment" bizPath="material" text="上传" isMultiple></j-image-upload>
                          </a-form-model-item>
                        </a-col>
                      </a-row>
                  </a-form-model>
                </div>
            </a-spin>
        </a-modal>
    </div>
  </template>
  <script>
  import JImageUpload from '@/components/jeecg/JImageUpload'
  import { ledgerAdd,ledgerEdit, getProductInfo, productAdd } from '@/api/api'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  export default {
    name: 'VendorModal',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      JImageUpload,
    },
    data() {
      return {
        port: '',
        portToCode: '', //串口扫码枪获取的数据
        title: '操作',
        visible: false,
        fileList: [],
        model: {},
        isReadOnly: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 18 },
        },
        confirmLoading: false,
        form: {
          code: '',
          productName: '',
          batchNumber: '',
          categoryCode:'',
          identificationCode: '',
          unit: '',
          specificationModel: '',
          productCategory: '',
          instrumentCategory: '',
          productDescription: '',
          storageTransportConditions: '',
          registrationFilingNo: '',
          medicalDeviceManagementCategory: '',
        },
        scannerCodeSupplierVO: {
          manufacturer: '',
          businessLicenceNumber: '',
          attachment: ''
        },
        uploadHeaders: {},
        action: window._CONFIG['domianURL'] + '/systemConfig/upload',
        rules: {
          code: [{ required: true, message: '编码不能为空!' }],
          productName: [{ required: true, message: '名称不能为空!' }],
          categoryCode: [{ required: true, message: '品类码不能为空!' }],
        },
        id: '',
      }
    },
    created() {
        // 判断浏览器支持串口通信
        if ("serial" in navigator) {
            console.log(true);
        } else {
            console.log(false);
        }
    },
    methods: {
      add() {
        this.edit({})
      },
      //扫码获取商品信息
      async getProductInfo(){
        let params= {
          code: this.form.code
        }
        const res = await getProductInfo(params)
        if( res.code == 200 && res.success == true){
          this.form = res.result.scannerCodeMaterialVO
          this.scannerCodeSupplierVO = res.result.scannerCodeSupplierVO
        } else {
          this.$message.error(res.message)
        }
      },
      async chooseSerial(){
        // 浏览器支持serial
        if ('serial' in navigator) {
            console.log('当前浏览器支持serial')

            const port = await navigator.serial.requestPort()
            await port.open({ baudRate: 115200})
            console.log("port的内容是：", port);
            const reader = port.readable.getReader();
            console.log("reader的内容是：", reader);
            let data = [];
            try{
              while(true){
                const {value,done} = await reader.read();
                console.log("done = ", done);
                if (done) {
                  reader.releaseLock();
                  break;
                }
                this.portToCode = value;

                data.push(...value);

                if(value[value.length - 1] == 13)
                {
                  this.Uint8Array(data)
                  data = [];
                }
              }
            }catch (error) {
              console.error(error)
            }finally {
              reader.releaseLock();
              console.log('允许稍后关闭串口。');
              //await readableStreamClosed.catch(() => { /* Ignore the error */ });
              await port.close();
            }
          }
      },
      containsCarriageReturn(str) {
        return /\r/g.test(str);
      },
      Uint8Array(serialData){

        var out, i, len, c;
        var char2, char3;
        out = "";
        len = serialData.length;
        i = 0;
        while(i < len) {
          c = serialData[i++];
          switch(c >> 4)
          {
            case 0: case 1: case 2: case 3: case 4: case 5: case 6: case 7:
            // 0xxxxxxx
            out += String.fromCharCode(c);
            break;
            case 12: case 13:
            // 110x xxxx   10xx xxxx
            char2 = serialData[i++];
            out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F));
            break;
            case 14:
            // 1110 xxxx  10xx xxxx  10xx xxxx
            char2 = serialData[i++];
            char3 = serialData[i++];
            out += String.fromCharCode(((c & 0x0F) << 12) |
                ((char2 & 0x3F) << 6) |
                ((char3 & 0x3F) << 0));
            break;
          }
        }
        console.log('999999999o==============00000000000',serialData)
        console.log('out的值是多少啊？：==============',out)
        this.portToCode = out
        this.form.code = out
        console.log('this.portToCode的值是多少啊？：==============',this.portToCode)
      },

      edit(record) {
        if (this.$refs.form !== undefined) this.$refs.form.resetFields()
        console.log(this.form, 'form')
        console.log(this.fileList, '数组')
        if (record.id) {
          this.getInfo(record.id)
          this.id = record.id
        } else {
          this.fileList = []
        }
        this.visible = true
        this.$nextTick(() => {})
      },
      handleChange({ file, fileList }) {
        console.log(file, 'file')
      },
      close() {
        this.$emit('close')
        this.visible = false
      },
      handleOk() {
        const that = this
        // 触发表单验证
        that.$refs['form'].validate(async (success) => {
          if (success === true) {
            // if (this.fileList.length == 0) return this.$message.warning('请上传至少一张图片')
            let params = {
              scannerCodeMaterialVO: {
                code: this.form.code,
                productName: this.form.productName,
                batchNumber: this.form.batchNumber,
                categoryCode: this.form.categoryCode,
                productInfoList: this.form.productInfoList,
                identificationCode: this.form.identificationCode,
                specificationModel: this.form.specificationModel,
                productCategory: this.form.productCategory,
                instrumentCategory: this.form.instrumentCategory,
                productDescription: this.form.productDescription,
                storageTransportConditions: this.form.storageTransportConditions,
                registrationFilingNo: this.form.registrationFilingNo,
                medicalDeviceManagementCategory: this.form.medicalDeviceManagementCategory,
              },
              scannerCodeSupplierVO: {
                manufacturer: this.scannerCodeSupplierVO.manufacturer,
                businessLicenceNumber: this.scannerCodeSupplierVO.businessLicenceNumber,
                attachment: this.scannerCodeSupplierVO.attachment
              },

            }
              const res = await productAdd(params)
              console.log(res, 'res')
              if (res.code == 200 && res.success == true) {
                this.$message.success(res.message)
                this.$refs.form.resetFields();
                this.close()
              } else {
                this.$message.error(res.message)
              }
          }
        })
      },
      handleCancel() {
        this.close()
      },
      validateSupplierName(rule, value, callback) {
        let params = {
          name: value,
          type: '供应商',
          id: this.model.id ? this.model.id : 0,
        }
        checkSupplier(params).then((res) => {
          if (res && res.code === 200) {
            if (!res.data.status) {
              callback()
            } else {
              callback('名称已经存在')
            }
          } else {
            callback(res.data)
          }
        })
      },
    },
  }
  </script>
  <style scoped>
    .productInfo {
      border: 1px solid #dedede;
      padding: 10px;
    }
    .productInfo .title {
        display: flex;
        font-size: 16px;
        border-left: 4px solid #1890FE;
        padding-left: 10px;
        margin: 20px 10px 10px;
    }
    .enterpriseTitle {
        width: 99%;
        display: flex;
        font-size: 16px;
        border-left: 4px solid #1890FE;
        padding-left: 10px;
        margin: 30px 10px;
    }
   /deep/.ant-form-item-children {
      display: flex;
    }
    .searchCode {
      margin-left: 10px;
    }
  </style>
<style>
.ant-form-item-with-help {
  margin-bottom: 5px !important;
}
</style>